module.exports = __webpack_public_path__ + "img/60-r.bbdba36b.png";